import { Injectable } from '@angular/core';
import { ModelService } from 'app/model/services/model.service';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from 'app/model/linkedservice/linkedservice';
import { Dataset } from 'app/model/dataset/dataset';
import { AirflowEntity } from 'app/model/airflowEntity/airflowEntity';
import { Pipeline } from 'app/model/pipeline/pipeline';
import { Trigger } from 'app/model/trigger/trigger';
import { DataFlow } from 'app/model/dataflow/dataflow';
import { IntegrationRuntime } from 'app/model/integrationRuntime/integrationRuntime';
import { ConnectableObservable } from 'rxjs';
import { SqlScript, Notebook, SqlPool, ManagedPrivateEndpoint, SqlDatabase } from 'shell-models-lib';
import { publishBehavior } from 'rxjs/operators';
import { WranglingDataflow } from 'app/model/dataflow/wranglingDataflow';
import { AdfDataMapper } from 'app/model/adfDataMapper/adfDataMapper';

@Injectable({
    providedIn: 'root'
})
export class ModelStoreService {
    public readonly linkedServices$ = this._modelService
        .list(undefined, Metamodel.modelFor(LinkedService))
        .pipe(publishBehavior([])) as ConnectableObservable<LinkedService[]>;

    public readonly datasets$ = this._modelService
        .list(undefined, Metamodel.modelFor(Dataset))
        .pipe(publishBehavior([])) as ConnectableObservable<Dataset[]>;

    public readonly pipelines$ = this._modelService
        .list(undefined, Metamodel.modelFor(Pipeline))
        .pipe(publishBehavior([])) as ConnectableObservable<Pipeline[]>;

    public readonly triggers$ = this._modelService
        .list(undefined, Metamodel.modelFor(Trigger))
        .pipe(publishBehavior([])) as ConnectableObservable<Trigger[]>;

    public readonly integrationRuntime$ = this._modelService
        .list(undefined, Metamodel.modelFor(IntegrationRuntime))
        .pipe(publishBehavior([])) as ConnectableObservable<IntegrationRuntime[]>;

    public readonly dataflows$ = this._modelService
        .list(undefined, Metamodel.modelFor(DataFlow))
        .pipe(publishBehavior([])) as ConnectableObservable<DataFlow[]>;

    public readonly powerquerys$ = this._modelService
        .list(undefined, Metamodel.modelFor(WranglingDataflow))
        .pipe(publishBehavior([])) as ConnectableObservable<WranglingDataflow[]>;

    public readonly notebooks$ = this._modelService
        .list(undefined, Metamodel.modelFor(Notebook))
        .pipe(publishBehavior([])) as ConnectableObservable<Notebook[]>;

    public readonly sqlScripts$ = this._modelService
        .list(undefined, Metamodel.modelFor(SqlScript))
        .pipe(publishBehavior([])) as ConnectableObservable<SqlScript[]>;

    public readonly sqlPool$ = this._modelService
        .list(undefined, Metamodel.modelFor(SqlPool))
        .pipe(publishBehavior([])) as ConnectableObservable<SqlPool[]>;

    public readonly sqlDatabase$ = this._modelService
        .list(undefined, Metamodel.modelFor(SqlDatabase))
        .pipe(publishBehavior([])) as ConnectableObservable<SqlDatabase[]>;

    public readonly managedPrivateEndpoint$ = this._modelService
        .list(undefined, Metamodel.modelFor(ManagedPrivateEndpoint))
        .pipe(publishBehavior([])) as ConnectableObservable<ManagedPrivateEndpoint[]>;

    public readonly airflowEntities$ = this._modelService
        .list(undefined, Metamodel.modelFor(AirflowEntity))
        .pipe(publishBehavior([])) as ConnectableObservable<AirflowEntity[]>;

    public readonly adfDatamapper$ = this._modelService
        .list(undefined, Metamodel.modelFor(AdfDataMapper))
        .pipe(publishBehavior([])) as ConnectableObservable<AdfDataMapper[]>;

    constructor(private readonly _modelService: ModelService) {
        this.linkedServices$.connect();
        this.datasets$.connect();
        this.pipelines$.connect();
        this.triggers$.connect();
        this.integrationRuntime$.connect();
        this.dataflows$.connect();
        this.powerquerys$.connect();
        this.notebooks$.connect();
        this.sqlScripts$.connect();
        this.sqlPool$.connect();
        this.sqlDatabase$.connect();
        this.managedPrivateEndpoint$.connect();
        this.airflowEntities$.connect();
        this.adfDatamapper$.connect();

    }
}
